// extracted by mini-css-extract-plugin
module.exports = {"th":"Cell_th__ZItH5","cell":"Cell_cell__9JoO5","item":"Cell_item__1OInS","itemTh":"Cell_itemTh__4Tp6m"};